import { render, staticRenderFns } from "./DSBlindEyeIcon.vue?vue&type=template&id=2fea1692&scoped=true&"
import script from "./DSBlindEyeIcon.vue?vue&type=script&lang=js&"
export * from "./DSBlindEyeIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fea1692",
  null
  
)

export default component.exports